import { render, staticRenderFns } from "./ViewMore.vue?vue&type=template&id=57aefc28"
import script from "./ViewMore.vue?vue&type=script&lang=js"
export * from "./ViewMore.vue?vue&type=script&lang=js"
import style0 from "./ViewMore.vue?vue&type=style&index=0&id=57aefc28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports